import {Indicadores} from '../../FriedmanModule/components/tienda.component';
import {devolverDiaSem, SemanaModel} from '../../FriedmanModule/models/semana.model';
import {EmpleadoSemanaModel} from '../../FriedmanModule/models/empleado.semana.model';
import * as moment from 'moment';

export class EmpleadoModel {
  id: string;
  nombre: string;
  indicadores: Indicadores;
  ventas: any[] = [];
  sem: SemanaModel;
  horario: TiempoEmpleModel[] = [];
  mallaEmple: EmpleadoSemanaModel;
  indMejorar: number = 0;
  dataGraficas: any = {};
  estado: string = '';
  cargo: any;
  doc: any;


  public static CREAREMPLEADO(data: any) {
    let emple = new EmpleadoModel();
    emple.id = data.id;
    emple.nombre = data.nombre;

    return emple;
  }


  constructor() {
    this.indicadores = new Indicadores();

    for (let i = 0; i < 7; i++) {
      let nh = new TiempoEmpleModel();
      nh.txtDia = devolverDiaSem(i);
      nh.activo = true;
      for (let j = 0; j < 48; j++) {
        nh.horasAct.push({hora: j, estado: false});
      }

      this.horario.push(nh);
    }


  }

  agregarVenta(venta: any) {
    if (venta.tipodoc.includes('VN') || venta.tipodoc.includes('VE') || venta.tipodoc.includes('NCE') || venta.tipodoc.includes('NCC')) {
      // console.log(`restando - ${venta.cantidad}`);
      this.indicadores.venta -= venta.cantidad;
      this.indicadores.cantVentas--;
      this.indicadores.ticket--;
    } else {
      this.indicadores.venta += venta.cantidad;
      this.indicadores.cantVentas++;
      this.indicadores.ticket++;
    }
    // this.indicadores.cantVentas++;
    this.ventas.push(venta);
  }

  calcularIndicadores(malla: EmpleadoSemanaModel) {
    // console.log('calculando indicadores');
    if (malla) {
      this.indicadores.meta = malla.metaTotal;

      if (this.indicadores.meta > 0)
        this.indicadores.completado = this.indicadores.venta / this.indicadores.meta * 100;
      else
        this.indicadores.completado = 0;

      if (this.indicadores.completado <= 89.99)
        this.indicadores.friedman = 0;
      else if (this.indicadores.completado <= 99.99)
        this.indicadores.friedman = 1;
      else if (this.indicadores.completado <= 109.99)
        this.indicadores.friedman = 2;
      else
        this.indicadores.friedman = 3;

      if (this.indicadores.cantVentas > 0)
        this.indicadores.ticketPromedio = this.indicadores.venta / this.indicadores.cantVentas;
      let cantArticulos = 0;
      this.ventas.map(v => {
        cantArticulos += v.articulos.length;
      });


      if (this.indicadores.cantVentas > 0) {

        this.indicadores.articulosTicket = cantArticulos / this.indicadores.cantVentas;
        // console.log(`calcuando articulos x ticket ${cantArticulos} - ${this.indicadores.cantVentas}`);
      }


      if (this.indicadores.cantVentas > 0)
        this.indicadores.ticketxDia = this.indicadores.cantVentas / 7;

      this.indicadores.ventaxDia = this.indicadores.venta / 7;

      this.indicadores.minimo = this.indicadores.meta * .9;

      this.dataGraficas = {
        'name': this.nombre,
        'series': [
          {
            'name': 'Meta',
            'value': this.indicadores.meta
          },
          {
            'name': 'Minimo',
            'value': this.indicadores.minimo
          },
          {
            'name': 'Venta',
            'value': this.indicadores.venta
          }
        ]
      };
    }


  }

  agregarDatos(datos, sem: SemanaModel) {
    this.nombre = datos.nombre;
    this.id = datos.id;
    this.sem = sem;
  }

  calcularVentaTicketxDia() {
    let dias: any[] = [];
    let totalTicket = 0;
    let totalVenta = 0;

    for (let i = 0; i < 7; i++) {
      dias[i] = {
        ticket: 0,
        venta: 0
      };
    }

    for (let v of this.ventas) {
      let fv = moment(v.fecha);

      let dw = fv.day();

      if (dw == 0)
        dw = 6;
      else
        dw -= 1;

      dias[dw].ticket++;
      totalTicket++;
      dias[dw].venta += v.cantidad;
      totalVenta += v.cantidad;
    }


    // ajustar para que sean por los dias activos
    return [totalTicket / 7, totalVenta / 7];

  }


}


export class TiempoEmpleModel {
  horasAct: any[] = [];
  activo: boolean;
  txtDia: string = '';
  esCompensado: boolean = false;
}



